import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TerminalDataModel } from '@nutricontrol/app360-shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportsService } from '../../reports.service';
import {
  ReportsIrrigationCostModel,
  ReportsWaterSourceModel,
} from '../../reports-irrigation.costs';
import {
  TranslationsLibService,
  IrrigationService,
} from '@nutricontrol/app360-shared';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-irrigation-cost-form',
  templateUrl: './irrigation-cost-form.component.html',
  styleUrls: ['./irrigation-cost-form.component.scss'],
})
export class IrrigationCostFormComponent implements OnInit {
  @Input() terminal: TerminalDataModel;
  @Input() source: ReportsIrrigationCostModel;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() formCancelled = new EventEmitter<void>();
  form: FormGroup;
  waterSystemsNums: number[] = [];
  waterSources: ReportsWaterSourceModel[] = [];
  isEditing: boolean;

  constructor(
    public translationLib: TranslationsLibService,
    private fb: FormBuilder,
    private reportsService: ReportsService,
    private irrigationService: IrrigationService
  ) {}

  ngOnInit(): void {
    this.isEditing = !!this.source;

    this.form = this.fb.group({
      water_system: [null, Validators.required],
      dateRange: this.fb.group({
        startDate: [null, Validators.required],
        endDate: [null, Validators.required],
      }),
      cost: ['', Validators.required],
      water_source_vid: [null],
    });

    this.loadWaterSystems();
    this.loadWaterSources();

    if (this.isEditing) {
      const startDate = new Date(this.source.start_date);
      startDate.setDate(startDate.getDate() + 1);
      const endDate = new Date(this.source.end_date);
      endDate.setDate(endDate.getDate() + 1);

      this.form.patchValue({
        water_system: this.source.water_system,
        dateRange: {
          startDate,
          endDate,
        },
        cost: this.source.cost,
        water_source_vid: this.source.water_source_vid,
      });
    }
  }

  loadWaterSystems() {
    this.irrigationService
      .getIrrigationEquipmentWithWaterSystems(this.terminal.vid)
      .subscribe({
        next: (irrigationEquipment) => {
          this.waterSystemsNums = Array.from(
            { length: irrigationEquipment.states.waterSystems.length },
            (_, i) => i
          );
        },
        error: (error) => {
          console.error('Error al obtener los cabezales:', error);
        },
      });
  }

  loadWaterSources() {
    this.reportsService.getWaterSources(this.terminal.vid).subscribe({
      next: (sources) => (this.waterSources = sources),
      error: (error) => console.error(error),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      const startDate = this.form.get('dateRange.startDate').value;
      startDate.setDate(startDate.getDate() + 1);
      const endDate = this.form.get('dateRange.endDate').value;
      endDate.setDate(endDate.getDate() + 1);

      const data = {
        terminal_vid: this.terminal.vid,
        type: 'irrigation',
        water_system: this.form.get('water_system').value,
        start_date: startDate,
        end_date: endDate,
        cost: this.form.get('cost').value,
        water_source_vid: this.form.get('water_source_vid').value,
      };
      if (this.isEditing) {
        this.reportsService
          .updateIrrigationCost(this.source.vid, data)
          .subscribe({
            next: () => {
              this.formSubmitted.emit();
              console.log('Costo de riego actualizado con éxito.');
            },
            error: (error) => {
              if (error.error === '[THROW IT] Overlapped input dates') {
                this.showOverlappedInputDatesAlert();
              }
            },
          });
      } else {
        this.reportsService.createIrrigationCost(data).subscribe({
          next: () => {
            this.formSubmitted.emit();
            console.log('Costo de riego creado con éxito.');
          },
          error: (error) => {
            if (error.error === '[THROW IT] Overlapped input dates') {
              this.showOverlappedInputDatesAlert();
            }
            console.error('Error al crear el costo de riego:', error);
          },
        });
      }
    }
  }

  cancel() {
    this.formCancelled.emit();
  }

  showOverlappedInputDatesAlert() {
    Swal.fire({
      title: this.translationLib.get('error'),
      text: this.translationLib.get('reports_irrigation_cost_exist_in_dates'),
      icon: 'warning',
      confirmButtonColor: '#224261',
    }).then();
  }
}
